import { initializeApp } from 'firebase/app';
import { getDatabase, connectDatabaseEmulator } from 'firebase/database';
import { getAuth, connectAuthEmulator } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyB_z6PnyuPvbBWKyumul8yFA91nkacLg9o",
  authDomain: "smlink-macro.firebaseapp.com",
  databaseURL: "https://smlink-macro-default-rtdb.firebaseio.com",
  projectId: "smlink-macro",
  storageBucket: "smlink-macro.appspot.com",
  messagingSenderId: "123456789012",
  appId: "1:123456789012:web:abcdef1234567890"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const database = getDatabase(app);

// 개발 환경에서 에뮬레이터 연결
if (import.meta.env.DEV && import.meta.env.VITE_USE_EMULATOR === 'true') {
  // Auth 에뮬레이터 연결
  connectAuthEmulator(auth, 'http://localhost:9099');
  
  // Database 에뮬레이터 연결
  connectDatabaseEmulator(database, 'localhost', 9000);
  
  console.log('Firebase Emulators 연결됨');
} else {
  console.log('실제 Firebase 서비스 연결됨');
}

// Firebase Realtime Database 경로
export const DB_PATHS = {
  MANAGER: 'manager',
  DRIVERS: 'driversm2',
  DRIVERLOGS: 'driverlogs',
  AUTOCALLLOGS: 'autocalllogs',
  DEPOSIT: 'deposit',
  DEPOSITLOGS: 'depositlogs'
} as const;

// Manager 테이블 구조
export interface Manager {
  phonenumber: string;    // 전화번호 (키로 사용)
  username: string;       // 사용자 이름
  password: string;       // 비밀번호
  grade: string;         // 권한 등급 (supermaster, localmaster)
  appname: string;       // 앱 이름
  block: string;         // 차단 여부
  initdate: string;      // 초기화 날짜
  referralcode: string;  // 추천 코드
}

// Deposit 테이블 구조
export interface Deposit {
  phonenumber: string;      // 전화번호 (키로 사용)
  username: string;         // 사용자 이름
  currentDeposit: number;   // 현재 예치금
  lastUpdateDate: string;   // 마지막 업데이트 일시 (yyyy-MM-dd hh:mm:ss)
}

// DepositLog 테이블 구조
export interface DepositLog {
  type: 'deposit' | 'withdraw';  // 입출금 구분
  amount: number;                // 금액
  date: string;                  // 일시 (yyyy-MM-dd hh:mm:ss)
} 